// @flow
import {
  trackLinkWithData,
  trackImpression,
  trackActivity,
} from 'lib/analytics/fpti'
import { tracking } from '../../lib/analytics/mParticle'

export const OPEN_BANKING_PAGE_GROUP =
  'main:p2p:send:bank_realtime_balance_user_consent'

const pageActionMap = {
  pageImpression: {
    pageGroup: OPEN_BANKING_PAGE_GROUP,
    pageName: `${OPEN_BANKING_PAGE_GROUP}:`,
    event_name: 'bank_realtime_balance_user_consent_screen_shown',
    event_type: 'im',
  },
  agreeAndLogin: {
    pageGroup: OPEN_BANKING_PAGE_GROUP,
    pageName: `${OPEN_BANKING_PAGE_GROUP}:`,
    link: 'agree and log in',
    event_name: 'bank_realtime_balance_user_consent_agree_pressed',
    event_type: 'cl',
  },
  payAnotherWay: {
    pageGroup: OPEN_BANKING_PAGE_GROUP,
    pageName: `${OPEN_BANKING_PAGE_GROUP}:`,
    link: 'pay another way',
    event_name: 'bank_realtime_balance_user_consent_deny_pressed',
    event_type: 'cl',
  },
}

/**
 * Track screen impression via FPTI analytics
 * @param {string} pageImpression - FPTI data to track with the impression
 */
export function trackOpenBankingImpression(pageImpression: string) {
  /**
   * "Y" means user consent available (in update consent flow);
   * "N" means user consent not available (in new consent flow).
   */
  const has_realtime_balance_user_consent =
    pageImpression === 'openBankingReConsent' ? 'Y' : 'N'
  const {
    event_name,
    event_type,
    pageGroup,
    pageName,
  } = pageActionMap.pageImpression
  /* Product requested to send previous FPTI requests.
     And both an Amplitude and FPTI for new taxonomy.
     https://engineering.paypalcorp.com/confluence/display/MUSIC/Open+Banking+Instrumentation+-+Phase+3+P2P
  */
  trackImpression(pageGroup, pageName, {
    rtb_consent: has_realtime_balance_user_consent,
  })

  trackImpression(pageGroup, pageName, {
    event_name,
    event_type,
    product: 'p2p',
    has_realtime_balance_user_consent,
  })

  tracking({
    event_name,
    event_type,
    has_realtime_balance_user_consent,
  })
}

/**
 * Track users clicks via FPTI analytics
 * @param {string} pageAction - FPTI data to track on clicks
 */
export function trackOpenBankingClick(pageAction: string) {
  const { event_name, event_type, pageGroup, pageName, link } = pageActionMap[
    pageAction
  ]
  // Product requested to send previous FPTI requests.
  // And both an Amplitude and FPTI for new taxonomy.
  // https://engineering.paypalcorp.com/confluence/display/MUSIC/Open+Banking+Instrumentation+-+Phase+3+P2P

  // FPTI
  // new taxonomy (must be sent BEFORE old taxonomy)
  // NOTE: trackLinkWithData already clear the data added to fpti at the end.
  trackLinkWithData(
    link,
    pageGroup,
    pageName,
    {
      event_name,
      event_type,
      product: 'p2p',
    },
    'link'
  )
  // old taxonomy
  trackLinkWithData(link, pageGroup, pageName, {}, 'link')

  // Amplitude
  // new taxonomy
  tracking({
    event_name,
    event_type,
    link,
  })
}

/**
 * Track users API calls FPTI analytics
 * @param {Object} pageAction - FPTI data to track
 */
export function trackOpenBankingAction(data: Object = {}) {
  const { pageGroup, pageName, ...extraData } = {
    event_type: 'ac',
    e: 'ac',
    ...data,
  }
  trackActivity(pageGroup, pageName, extraData)
  tracking(extraData)
}
